<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" />
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="user_center">用户中心</DropdownItem>
        <DropdownItem name="user_password">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      getUser: "getUser"
    })
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.handleLogOut().then(() => {
            this.$router.push({
              name: 'login'
            })
          })
          break;
        case "user_center":
          let userId = localStorage.getItem("userId");
          this.$router.push({
            path: "/user/user_centered",
            query: { userId: userId }
          });
          break;
        case "user_password":
          let user = localStorage.getItem("userId");
          this.$router.push({
            path: "/user/user_password",
            query: { user: user }
          });
          break;
      }
    }
  }
}
</script>
